export default __webpack_public_path__ + "static/gsod-bdae86e80935b6dc17caa4239c795ecc.webp";